import React, { useEffect, useState } from 'react';
import { useStyles } from "./styles";
import { generalStyles } from "../general/general";
import { mobilosLogo, getInTouch, whatsapp } from "../../../assets/images/images";
import "../scss/footer.scss";
import "../scss/general.scss";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import { useMediaQuery, Container, Grid, Typography, Button } from '@material-ui/core';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import ReactPlayer from 'react-player/lazy'
import { getInTouchBGVideo } from '../../../assets/videos/videos';
import { AnimatedIcon } from "../../../components";

function Footer(props) {
  const classes = useStyles();
  const generalClasses = generalStyles();
  const matches = useMediaQuery('(max-width: 767px)')
  const isSmallScreen = useMediaQuery('(max-width:1199px)');

  return (
    <div className={generalClasses.root}>
      <div className="whatsapp-animat">
        <a href={"https://wa.me/" + 12027584481} target="_blank">
          <AnimatedIcon icon={whatsapp} height={60} width={60} />
        </a>
      </div>
      <section>
        <div className='positionRelative' style={{ backgroundImage: `url(${getInTouch})` }}>
          <span className='vid-gradient'></span>
          <div className="video-wrapper">
            <ReactPlayer url={getInTouchBGVideo} width="100%" height="100%" loop muted playing />
          </div>
          <Container className='video-content-wra'>
            <Grid container>
              <div className="get-in-touch-inner">
                <div className="get-in-touch-left">
                  <h3> Starting your business? Leave the hiring process to us.</h3>
                  <span>
                    Experience the best services by tech talent without getting exhausted through the hiring process. Hire an expert developer, designer or QA engineer now!
                  </span>
                </div>

                <div className='width-100'>
                  <Button variant='contained' className='get-in-touch-btn' onClick={() => props.history.push('/contact-us')} >Get In Touch</Button>
                </div>
              </div>
            </Grid>
          </Container>
        </div>
      </section>
      <section className='footer-section'>
        <Container>
          <Grid container spacing={isSmallScreen ? 3 : 10}>
            <Grid item xs={12} sm={12} md={12} lg={3}  >
              <div className='footer-text-center'>
                <div>
                  <img onClick={() => props.history.push('/')} src={mobilosLogo} alt='logo' className='footer-img-logo' />
                </div>
                <Typography className='footer-p-text'>
                  we work with a passion of taking
                  challenges and creating new ones in
                  advertising sector
                </Typography>
              </div>
              <div className='footersocial-icon'>
                <ul>
                  <li>Follow Us: </li>
                  <li>
                    <a>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_0_185)">
                          <path d="M19.7778 9.88889C19.7778 4.4274 15.3504 0 9.88889 0C4.4274 0 0 4.4274 0 9.88889C0 14.8246 3.6162 18.9158 8.34375 19.6576V12.7474H5.8329V9.88889H8.34375V7.71024C8.34375 5.23184 9.82013 3.86285 12.0789 3.86285C13.1605 3.86285 14.2925 4.05599 14.2925 4.05599V6.48958H13.0456C11.8172 6.48958 11.434 7.25192 11.434 8.03472V9.88889H14.1767L13.7382 12.7474H11.434V19.6576C16.1616 18.9158 19.7778 14.8246 19.7778 9.88889Z" fill="#222222" />
                        </g>
                        <defs>
                          <clipPath id="clip0_0_185">
                            <rect width="19.7778" height="19.7778" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_0_187)">
                          <path d="M6.22189 17.9236C13.6834 17.9236 17.7656 11.7403 17.7656 6.37982C17.7656 6.20599 17.7618 6.0283 17.754 5.85447C18.5482 5.28018 19.2335 4.56883 19.7778 3.75386C19.0382 4.08291 18.2529 4.29781 17.4489 4.39123C18.2955 3.88374 18.9294 3.0865 19.2331 2.1473C18.4366 2.61932 17.5656 2.95229 16.6574 3.13194C16.0454 2.4817 15.2363 2.05117 14.3551 1.9069C13.4739 1.76264 12.5698 1.91267 11.7824 2.33381C10.995 2.75495 10.3683 3.42374 9.99919 4.23677C9.63004 5.04981 9.53901 5.96181 9.74017 6.83177C8.12742 6.75084 6.54969 6.33189 5.10924 5.60209C3.6688 4.87228 2.3978 3.84791 1.37865 2.59539C0.860663 3.48846 0.702158 4.54525 0.935349 5.55099C1.16854 6.55673 1.77593 7.43594 2.63408 8.00994C1.98983 7.98949 1.3597 7.81603 0.795747 7.50391V7.55412C0.795169 8.49134 1.11917 9.39983 1.71268 10.1252C2.30619 10.8505 3.13257 11.3479 4.05135 11.5329C3.45456 11.6961 2.82821 11.7199 2.22075 11.6024C2.48001 12.4084 2.98444 13.1134 3.66364 13.6189C4.34284 14.1244 5.16292 14.4053 6.00943 14.4223C4.57231 15.5511 2.79705 16.1634 0.969575 16.1605C0.645487 16.1601 0.321718 16.1402 0 16.1011C1.85652 17.2921 4.01615 17.9247 6.22189 17.9236Z" fill="#222222" />
                        </g>
                        <defs>
                          <clipPath id="clip0_0_187">
                            <rect width="19.7778" height="19.7778" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_0_189)">
                          <path d="M9.88889 1.78077C12.5311 1.78077 12.844 1.79236 13.8831 1.83872C14.8488 1.88121 15.3703 2.04345 15.7179 2.17865C16.1776 2.35634 16.5098 2.57266 16.8536 2.91645C17.2013 3.26411 17.4137 3.59245 17.5914 4.05213C17.7266 4.39978 17.8888 4.92513 17.9313 5.88698C17.9777 6.92995 17.9893 7.24284 17.9893 9.88116C17.9893 12.5234 17.9777 12.8362 17.9313 13.8753C17.8888 14.8411 17.7266 15.3625 17.5914 15.7102C17.4137 16.1699 17.1974 16.5021 16.8536 16.8459C16.5059 17.1935 16.1776 17.406 15.7179 17.5837C15.3703 17.7189 14.8449 17.8811 13.8831 17.9236C12.8401 17.97 12.5272 17.9816 9.88889 17.9816C7.2467 17.9816 6.93381 17.97 5.89471 17.9236C4.92899 17.8811 4.40751 17.7189 4.05985 17.5837C3.60017 17.406 3.26797 17.1897 2.92418 16.8459C2.57652 16.4982 2.36406 16.1699 2.18637 15.7102C2.05117 15.3625 1.88893 14.8372 1.84644 13.8753C1.80009 12.8324 1.7885 12.5195 1.7885 9.88116C1.7885 7.23898 1.80009 6.92608 1.84644 5.88698C1.88893 4.92127 2.05117 4.39978 2.18637 4.05213C2.36406 3.59245 2.58038 3.26024 2.92418 2.91645C3.27183 2.56879 3.60017 2.35634 4.05985 2.17865C4.40751 2.04345 4.93286 1.88121 5.89471 1.83872C6.93381 1.79236 7.2467 1.78077 9.88889 1.78077ZM9.88889 0C7.20421 0 6.86814 0.0115885 5.81359 0.0579427C4.76289 0.104297 4.04054 0.274262 3.41476 0.517622C2.76194 0.772569 2.20955 1.10864 1.66102 1.66102C1.10864 2.20955 0.772569 2.76194 0.517622 3.41089C0.274262 4.04054 0.104297 4.75903 0.0579427 5.80972C0.0115885 6.86814 0 7.20421 0 9.88889C0 12.5736 0.0115885 12.9096 0.0579427 13.9642C0.104297 15.0149 0.274262 15.7372 0.517622 16.363C0.772569 17.0158 1.10864 17.5682 1.66102 18.1168C2.20955 18.6653 2.76194 19.0052 3.41089 19.2563C4.04054 19.4997 4.75903 19.6696 5.80972 19.716C6.86428 19.7623 7.20035 19.7739 9.88503 19.7739C12.5697 19.7739 12.9058 19.7623 13.9603 19.716C15.011 19.6696 15.7334 19.4997 16.3592 19.2563C17.0081 19.0052 17.5605 18.6653 18.109 18.1168C18.6576 17.5682 18.9975 17.0158 19.2486 16.3669C19.4919 15.7372 19.6619 15.0188 19.7082 13.9681C19.7546 12.9135 19.7662 12.5774 19.7662 9.89275C19.7662 7.20807 19.7546 6.87201 19.7082 5.81745C19.6619 4.76675 19.4919 4.0444 19.2486 3.41862C19.0052 2.76194 18.6691 2.20955 18.1168 1.66102C17.5682 1.1125 17.0158 0.772569 16.3669 0.521484C15.7372 0.278125 15.0188 0.10816 13.9681 0.0618056C12.9096 0.0115885 12.5736 0 9.88889 0Z" fill="#222222" />
                          <path d="M9.88873 4.80933C7.0843 4.80933 4.80908 7.08454 4.80908 9.88897C4.80908 12.6934 7.0843 14.9686 9.88873 14.9686C12.6932 14.9686 14.9684 12.6934 14.9684 9.88897C14.9684 7.08454 12.6932 4.80933 9.88873 4.80933ZM9.88873 13.184C8.06933 13.184 6.59372 11.7084 6.59372 9.88897C6.59372 8.06957 8.06933 6.59396 9.88873 6.59396C11.7081 6.59396 13.1837 8.06957 13.1837 9.88897C13.1837 11.7084 11.7081 13.184 9.88873 13.184Z" fill="#222222" />
                          <path d="M16.3552 4.60826C16.3552 5.26494 15.8221 5.79415 15.1693 5.79415C14.5126 5.79415 13.9834 5.26108 13.9834 4.60826C13.9834 3.95157 14.5165 3.42236 15.1693 3.42236C15.8221 3.42236 16.3552 3.95544 16.3552 4.60826Z" fill="#222222" />
                        </g>
                        <defs>
                          <clipPath id="clip0_0_189">
                            <rect width="19.7778" height="19.7778" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_0_194)">
                          <path d="M18.3138 0H1.46016C0.652821 0 0 0.63737 0 1.42539V18.3485C0 19.1365 0.652821 19.7778 1.46016 19.7778H18.3138C19.1211 19.7778 19.7778 19.1365 19.7778 18.3524V1.42539C19.7778 0.63737 19.1211 0 18.3138 0ZM5.86766 16.8536H2.9319V7.4128H5.86766V16.8536ZM4.39978 6.12648C3.45725 6.12648 2.69627 5.36549 2.69627 4.42682C2.69627 3.48815 3.45725 2.72717 4.39978 2.72717C5.33846 2.72717 6.09944 3.48815 6.09944 4.42682C6.09944 5.36163 5.33846 6.12648 4.39978 6.12648ZM16.8536 16.8536H13.9217V12.2645C13.9217 11.1714 13.9024 9.76141 12.3959 9.76141C10.8701 9.76141 10.6383 10.955 10.6383 12.1873V16.8536H7.71024V7.4128H10.5224V8.703H10.561C10.9512 7.96133 11.9092 7.17717 13.3345 7.17717C16.3051 7.17717 16.8536 9.13177 16.8536 11.6735V16.8536Z" fill="#222222" />
                        </g>
                        <defs>
                          <clipPath id="clip0_0_194">
                            <rect width="19.7778" height="19.7778" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} className='footer-nav-list footer-text-center'>
              <Typography component='h3'>Category<span>.</span></Typography>
              <ul>
                <li>
                  <RouterLink to="/hiring/6482d5fa8cb990e9bb3889b8" >Java Developers</RouterLink>
                </li>
                <li>
                  <RouterLink to="/hiring/6482d5fa8cb990e9bb3889c2" >Android App Developers</RouterLink>
                </li>
                <li>
                  <RouterLink to="/hiring/6482d5fa8cb990e9bb3889cc" >QA Engineer</RouterLink>
                </li>
                <li>
                  <RouterLink to="/hiring/6482f3fa9ca340906a8e98ca" >Game Developers</RouterLink>
                </li>
                <li>
                  <RouterLink to="/hiring/6482d5fa8cb990e9bb3889c6" >UI/UX Engineer</RouterLink>
                </li>
                <li>
                  <RouterLink to="/hiring/6482d5fa8cb990e9bb3889ce" >Social Media Marketing Experts</RouterLink>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} className='footer-nav-list footer-text-center'>
              <Typography component='h3'>About<span>.</span></Typography>
              <ul>
                <li>
                  <RouterLink to="/" >Help & Support</RouterLink>
                </li>
                <li>
                  <RouterLink to="/contact-us" >Contact Us</RouterLink>
                </li>
                <li>
                  <RouterLink to="/" >Services</RouterLink>
                </li>
                <li>
                  <RouterLink to="/" >Terms of Services</RouterLink>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} className='footer-nav-list footer-text-center'>
              <Typography component='h3'>Address<span>.</span></Typography>
              <ul>
                <li>
                  1610A N Queen St, Apt 214, Arlington, VA, 22209, USA
                </li>
              </ul>

              <Typography component='h3'>Contact<span>.</span></Typography>
              <ul>
                <li>
                  Contact: +1 202 758 4481
                </li>
              </ul>
              {/* <ul>
                <li>
                  <RouterLink></RouterLink>
                </li>
                
              </ul> */}
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className='footer-sec-bg'>
        <Container>
          <Grid
            container
            direction="row"
          >
            <Grid item xs={12}>
              <div className='cpyright'>
                <span className="copyright-text">
                  Copyright © {new Date().getFullYear()} <span>Mobilos</span>. All rights reserved
                </span>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>
    </div>
  );
}

//what is needed at start
const mapStateToProps = ({ }) => {
  return {};
};
//which actions our function can dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Footer));
